module.exports = __webpack_public_path__ + "static/media/arrow-left.104793ea.svg";